/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateSessionDto } from './create-session-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateProgramSessionDto
 */
export interface CreateProgramSessionDto {

    /**
     * Delay in SECONDS from the assignment start at which this session is scheduled. Day 0 is 0, day 1 is 86400. Not milliseconds — the value is consumed as seconds when the program is assigned.
     *
     * @type {number}
     * @memberof CreateProgramSessionDto
     */
    offset: number;

    /**
     * @type {string}
     * @memberof CreateProgramSessionDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateProgramSessionDto
     */
    program?: JoinEntityDto;

    /**
     * @type {CreateSessionDto | JoinEntityDto}
     * @memberof CreateProgramSessionDto
     */
    session: CreateSessionDto | JoinEntityDto;
}
